import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import nomadDataProductHome from '../../../images/NomadDataProductHome.svg';
import classnames from 'classnames';
import styles from './noDataVendors.module.scss';
import CreateDataProviderModal from 'v2/common/DataVendorModals/CreateDataProviderModal/CreateDataProviderModal';
import { Link } from 'react-router-dom';
import { GenericObject, Permission, User } from 'v2/models';
import { connect } from 'react-redux';
import { hasPlanFamily } from 'v2/utils/permissions';
import { OverlayInjectedProps } from 'react-bootstrap/esm/Overlay';
import BulkImportModal from 'v2/common/BulkImport/BulkImportModal/BulkImportModal';
import { useTranslation } from 'react-i18next';
import { TranslationKeys } from 'translations';
import { BulkImportType } from 'v2/common/BulkImport/BulkImportModal/formSteps/FileSelection/hooks';

interface StateProps {
  user: User;
  permissions: { [key: string]: Permission };
}
const renderTooltip = (props: OverlayInjectedProps) => (
  <Tooltip id="subscribe-to-connect-tooltip" {...props}>
    <div>Your account is being reviewed. Check back soon to subscribe!</div>
  </Tooltip>
);

const NoDataVendors = ({ user, permissions }: StateProps) => {
  const { t } = useTranslation();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showBulkImportModal, setShowBulkImportModal] = useState(false);

  return (
    <div className={classnames(styles.dataVendorsContainer)}>
      <div
        className={classnames(
          'w-100 d-flex align-items-center bg-white',
          'position-relative',
          styles.root
        )}
      >
        <div className={classnames('position-absolute', styles.infoContainer)}>
          <h1 className={styles.title}>You Have No Data Providers, yet!</h1>
          <p className={classnames(styles.subtitle)}>
            Click below to create one now or upload multiple providers in bulk.
          </p>

          <div className={classnames('d-flex', styles.buttonsContainer)}>
            <Button
              data-testid="addNewDataProviderButton"
              data-cy="datavendor:create-button"
              type="button"
              className={classnames(styles.homePageButton)}
              variant="secondary"
              size="sm"
              onClick={() => {
                setShowCreateModal(true);
              }}
            >
              Add New Data Provider
            </Button>
            <Button
              data-testid="bulkImportProviderButton"
              data-cy="datavendor:bulk-import-button"
              type="button"
              className={classnames(styles.homePageButton)}
              variant="secondary"
              size="sm"
              onClick={() => setShowBulkImportModal(true)}
            >
              Bulk Upload Data Providers
            </Button>
          </div>

          {!hasPlanFamily(permissions, 'enterprise') && (
            <>
              <p className={classnames(styles.subtitle)}>
                Or subscribe to Connect below to search for a{' '}
                {t(TranslationKeys.dataProvider_one)}. Learn more about Connect{' '}
                <a
                  href="https://www.nomad-data.com/connect"
                  target="_blank"
                  rel="noreferrer"
                >
                  here.
                </a>
              </p>
              <OverlayTrigger
                placement="top"
                overlay={(props) => renderTooltip(props)}
                show={user.waitlisted ? undefined : false}
              >
                <span
                  className={classnames('d-inline-block', {
                    [styles.showTooltip]: user.waitlisted,
                  })}
                >
                  <Link
                    data-testid="subscribeToConnectButton"
                    to={'/settings/subscription'}
                    className={classnames(
                      'btn btn-secondary',
                      styles.homePageButton,
                      { [styles.disabled]: user.waitlisted }
                    )}
                  >
                    Subscribe to connect
                  </Link>
                </span>
              </OverlayTrigger>
            </>
          )}
        </div>

        <img
          className={classnames('img-fluid', styles.heroImage)}
          src={nomadDataProductHome}
          alt="nomadDataProductHome"
        ></img>
      </div>
      <CreateDataProviderModal
        show={showCreateModal}
        onClose={() => setShowCreateModal(false)}
      />
      {showBulkImportModal && (
        <BulkImportModal
          defaultBulkImportType={BulkImportType.DATA_VENDOR}
          onClose={() => setShowBulkImportModal(false)}
        />
      )}
    </div>
  );
};
const mapStateToProps = (state: GenericObject) => {
  return {
    user: state.user.user,
    permissions: state.permissions.permissions,
  };
};

export default connect<StateProps>(mapStateToProps)(NoDataVendors);
